import React from 'react';

export default function UserCircle() {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z'
        fill='#27272A'
      />
      <g clipPath='url(#clip0_417_8108)'>
        <path
          d='M20.0007 21.3333C20.0007 20.2724 19.5792 19.255 18.8291 18.5048C18.0789 17.7547 17.0615 17.3333 16.0007 17.3333M16.0007 17.3333C14.9398 17.3333 13.9224 17.7547 13.1722 18.5048C12.4221 19.255 12.0007 20.2724 12.0007 21.3333M16.0007 17.3333C17.4734 17.3333 18.6673 16.1393 18.6673 14.6666C18.6673 13.1938 17.4734 11.9999 16.0007 11.9999C14.5279 11.9999 13.334 13.1938 13.334 14.6666C13.334 16.1393 14.5279 17.3333 16.0007 17.3333ZM22.6673 15.9999C22.6673 19.6818 19.6826 22.6666 16.0007 22.6666C12.3188 22.6666 9.33398 19.6818 9.33398 15.9999C9.33398 12.318 12.3188 9.33325 16.0007 9.33325C19.6826 9.33325 22.6673 12.318 22.6673 15.9999Z'
          stroke='#A1A1AA'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_417_8108'>
          <rect
            width='16'
            height='16'
            fill='white'
            transform='translate(8 8)'
          />
        </clipPath>
      </defs>
    </svg>
  );
}
